import styled from "styled-components";

import { ActiveViewSwitch } from "@/components/layout/Sidebar/SidebarControls/ActiveViewSwitch";
import { ClusterFilter } from "@/components/layout/Sidebar/SidebarControls/ClusterFilter";
import { SidebarControlsSeparator } from "@/components/layout/Sidebar/SidebarControls/SidebarControlsSeparator";
import { UserRoleSelect } from "@/components/layout/Sidebar/SidebarControls/UserRoleSelect";
import { useHasUserArea } from "@/hooks/useHasUserArea";

const SidebarControlsStyled = styled.div``;

const SidebarControls = () => {
    const hasNewPermissionSystem = useHasUserArea(["NewPermissionSystem"]);

    return (
        <SidebarControlsStyled>
            {hasNewPermissionSystem ? <ActiveViewSwitch /> : <UserRoleSelect />}
            <ClusterFilter />
            <SidebarControlsSeparator />
        </SidebarControlsStyled>
    );
};

export { SidebarControls };
